import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function AddResignationModal({ show, handleClose }) {
  const [form, setForm] = useState({
    employee: "",
    noticeDate: "",
    resignationDate: "",
    reason: "",
  });

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">
          Add Resignation
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* Employee */}
          <Form.Group className="mb-3">
            <Form.Label>Resigning Employee</Form.Label>
            <Form.Select>
              <option>Select</option>
              <option>John</option>
              <option>David</option>
            </Form.Select>
          </Form.Group>

          {/* Notice Date */}
          <Form.Group className="mb-3">
            <Form.Label>Notice Date</Form.Label>
            <Form.Control type="date" />
          </Form.Group>

          {/* Resignation Date */}
          <Form.Group className="mb-3">
            <Form.Label>Resignation Date</Form.Label>
            <Form.Control type="date" />
          </Form.Group>

          {/* Reason */}
          <Form.Group>
            <Form.Label>Reason</Form.Label>
            <Form.Control as="textarea" rows={4} />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="btn-orange">
          Add Resignation
        </Button>
      </Modal.Footer>
    </Modal>
  );
}